export { default } from '../../MediaContainer/viewer/MediaContainer';
